import basicStyle from 'assets/styles/constants';
import SuperFetch from 'library/helpers/superFetch';
import fieldsValidator from 'library/helpers/validators/fieldsValidator';
import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { floorsActions } from 'reduxStore/floors/slice';
import { Button, Flex, Form, Input, Modal } from 'zui/Antd';
import { isEqual } from 'lodash';
import { Notification } from 'zComponents/atoms';
import { ConditionalTooltipButton } from 'zui/Custom';
import { theme } from 'antd';

const { TextArea } = Input;

const { colStyle } = basicStyle;

const EditFloorModal = ({ data, children }) => {
	const {
		token: { colorTextDescription }
	} = theme.useToken();
	// Hooks
	const dispatch = useDispatch();
	const [form] = Form.useForm();

	// Local States
	const [buttonDisabled, setButtonDisabled] = useState(true);
	const [visible, setVisible] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleCancel = () => {
		setVisible(false);
		form.resetFields();
		setButtonDisabled(true);
		setLoading(false);
	};

	// Check if form values are different from the initial data
	const updateChange = () => {
		const formData = form.getFieldsValue(true);
		setButtonDisabled(isEqual(formData, data));
	};

	const onFinish = () => {
		const newFloorInfo = {};
		const formData = form.getFieldsValue(true);
		if (formData.name !== data.name && formData.name !== '') {
			newFloorInfo.name = formData.name;
		}
		if (formData.description !== data.description && formData.description !== '') {
			newFloorInfo.description = formData.description;
		}
		setLoading(true);
		SuperFetch.patch('/floors/' + data.floorID, newFloorInfo)
			.then((res) => {
				if (res) {
					if (res.statusCode === 200) {
						Notification('success', 'Floors Information Updated.');
					}
					dispatch(floorsActions.loadFloors());
				}
				handleCancel();
				return res;
			})
			.catch(() => {
				setLoading(true);
				Notification('error', 'Update Failed, Please try again.');
			});
	};

	return (
		<Fragment>
			<ConditionalTooltipButton
				buttonText={'Edit Floor'}
				// condition={true}
				// disabledCondition={false}
				trueTitle={''}
				falseTitle={''}
				onClick={() => setVisible(true)}
			>
				{children}
			</ConditionalTooltipButton>
			<Modal title='Edit Floor' open={visible} onCancel={handleCancel} footer={null} destroyOnClose={true}>
				<Form
					form={form}
					labelCol={{
						lg: { span: 6, offset: 0 },
						sm: { span: 6, offset: 0 }
					}}
					wrapperCol={{
						lg: { span: 20 },
						sm: { span: 16 },
						xs: { span: 10 }
					}}
					onFinish={onFinish}
					initialValues={data}
					autoComplete='off'
					onValuesChange={updateChange}
				>
					<Form.Item label='Name' name='name' rules={fieldsValidator.Name}>
						<Input />
					</Form.Item>

					<Form.Item
						label='Description'
						name='description'
						rules={fieldsValidator.Description}
						style={colStyle}
					>
						<TextArea
							style={{ color: colorTextDescription }}
							allowClear
							autoSize={{ minRows: 2, maxRows: 6 }}
						/>
					</Form.Item>

					<Flex justify='flex-end' gap={8}>
						<Button key='back' onClick={handleCancel}>
							Cancel
						</Button>
						<Button
							key='submit'
							htmlType='submit'
							type='primary'
							loading={loading}
							disabled={buttonDisabled}
						>
							Update
						</Button>
					</Flex>
				</Form>
			</Modal>
		</Fragment>
	);
};

export default EditFloorModal;
